import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { type PackageFormType, store } from "../../_store";
import { errorHandler } from "../../_utils";
import { setCategories, setCategoryLoading } from "../slices/categorySlice";

export const getCategories = async (notify: MessageInstance) => {
  try {
    store.dispatch(setCategoryLoading(true));
    const response = await privateAPI.get("/category");
    if (response) {
      store.dispatch(setCategoryLoading(false));
      store.dispatch(setCategories(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setCategoryLoading(false));
    console.error("Get Category Error:", error);
    errorHandler(error, notify);
  }
};

export const createCategory = async (
  notify: MessageInstance,
  payload: PackageFormType,
) => {
  try {
    store.dispatch(setCategoryLoading(true));
    const { data } = await privateAPI.post("/category", payload);
    notify.success("Category created successfully!");
    return data;
  } catch (error) {
    console.error("Create Package Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setCategoryLoading(false));
  }
};

export const updateCategory = async (
  notify: MessageInstance,
  payload: PackageFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setCategoryLoading(true));
    const { data } = await privateAPI.put(`/category/${payload.id}`, payload);
    notify.success("Category updated successfully!");
    return data;
  } catch (error) {
    console.error("Update Category Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setCategoryLoading(false));
  }
};

export const deleteCategory = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setCategoryLoading(true));
    const response = await privateAPI.delete(`/category/${id}`);
    if (response) {
      getData && (await getCategories(notify));
    }
    notify.success("Category deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Category Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setCategoryLoading(false));
  }
};
